import { render, staticRenderFns } from "./find-id.vue?vue&type=template&id=3c51a6f2&"
import script from "./find-id.vue?vue&type=script&lang=js&"
export * from "./find-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports